<template>
  <div>
    <div class="row">

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="text-center mb-3">
              <h4 class="mb-0">{{ product.name || "N/A" }}</h4>
              <p class="mb-2">{{ product.type || "N/A" }}</p>
            </div>
            <ul class="list-group list-group-flush mb-2">
              <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                <h6 class="mb-0">Name</h6>
                <span v-if="!edit" class="text-white">{{ product.name || "N/A" }}</span>
                <input v-else class="form-control" style="width: 75%;" type="text" v-model="product.name">
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                <h6 class="mb-0">Type</h6>
                <span v-if="!edit" class="text-white">{{ product.type || "N/A" }}</span>
                <input v-else class="form-control" style="width: 75%;" type="text" v-model="product.type">
              </li>
            </ul>

            <submit-button v-if="$hasOneOfRoles('Support', 'Admin')" :background="'btn btn-sm btn-primary ms-2'"
              style="float: right;" :clicked='updating' @click="saveChanges" :text="'Save Changes'"></submit-button>
            <button v-if="$hasOneOfRoles('Support', 'Admin')" class="btn btn-sm"
              :class="{ 'btn-light': !edit, 'btn-danger': edit }" @click="edit = !edit" style="float: right;">{{ edit ?
                'Stop Editing' : 'Edit' }}</button>
          </div>
        </div>
      </div>

      <div v-if="$hasOneOfRoles('Support', 'Admin')" class="col-lg-8">
        <!-- Associated Products -->
        <div class="row">
          <div class="card">
            <div class="card-body">

              <h5 class="card-title">Associated Products <button data-bs-toggle="modal"
                  data-bs-target="#associateProductModal" class="btn btn-success btn-sm float-end">Add Product</button>
              </h5>

              <table id="example" class="table table-hover" style="width:100%">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Quantity</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="product in products" :key="product.id + '-product'" style="cursor: pointer;">
                    <td>{{ product.child_product_name }}</td>
                    <td>{{ product.child_product_quantity }}</td>
                    <td>
                      <button class="btn btn-sm btn-danger" @click="removeProduct(product.id)">Remove</button>
                      <button class="btn btn-sm btn-primary ms-2"
                        @click="openProductModal(product.id, product.child_product_quantity)">Edit</button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th>Name</th>
                    <th>Quantity</th>
                    <th></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- MODALS -->

      <div class="modal fade" id="associateProductModal" tabindex="-1" style="display: none;" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Create Product</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12 mb-2">
                  <p>Fields marked <span class="text-danger">*</span> are required</p>
                </div>
                <div class="col-md-12 mb-2">
                  <label for="productName" class="form-label">Product <span class="text-danger">*</span></label>
                  <Multiselect v-model="associatedProduct.child_product_id" id="newChildProduct" valueProp="id"
                    label="name" :searchable="true" :options="allProducts"></Multiselect>
                </div>
                <div class="col-md-12 mb-2">
                  <label for="productType" class="form-label">Quantity <span class="text-danger">*</span></label>
                  <input type="number" min="0.00" step="1" class="form-control" id="productQuantity"
                    v-model="associatedProduct.quantity">
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                id='closeAssociateProductModal'>Close</button>
              <submit-button type="button" :background="'btn btn-primary'" :clicked="creating" @click="associateProduct"
                text="Save changes"></submit-button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="editProductModal" tabindex="-1" style="display: none;" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Product</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12 mb-2">
                  <p>Fields marked <span class="text-danger">*</span> are required</p>
                </div>
                <div class="col-md-12 mb-2">
                  <label for="productType" class="form-label">Quantity <span class="text-danger">*</span></label>
                  <input type="number" min="0.00" step="1" class="form-control" id="productQuantity"
                    v-model="associatedProduct.quantity">
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                id='closeEditProductModal'>Close</button>
              <submit-button type="button" :background="'btn btn-primary'" :clicked="updating" @click="editProduct"
                text="Save changes"></submit-button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* global $ */
import axios from "axios";
import SubmitButton from "../../../components/SubmitButton";
import Multiselect from '@vueform/multiselect'

export default {
  name: 'admin.products.view',
  props: ['id'],
  components: {
    Multiselect,
    SubmitButton
  },
  data() {
    return {
      product: {
        name: "",
        type: ""
      },
      products: [],
      allProducts: [],
      associatedProduct: {
        child_product_id: null,
        quantity: 1
      },
      edit: false,
      updating: false,
      creating: false
    }
  },
  mounted() {
    this.loadProduct(),
      this.loadAssociatedProducts(),
      this.loadAllProducts()
  },
  methods: {
    loadProduct() {
      axios.get(`${process.env.VUE_APP_API_URL}/v1/product/${this.id}`)
        .then(response => {
          this.product = response.data.product;
        })
        .catch(error => {
          this.$error("Failed to load product.", error);
        })
    },
    loadAssociatedProducts() {
      axios.get(`${process.env.VUE_APP_API_URL}/v1/product/${this.id}/associate`)
        .then(response => {
          this.products = response.data.products;
        })
        .catch(error => {
          console.log(error);
          this.$error("Failed to load associated products.", error);
        })
    },
    loadAllProducts() {
      axios.get(`${process.env.VUE_APP_API_URL}/v1/product/list`)
        .then(response => {
          this.allProducts = response.data.products;
          this.allProducts.forEach((product) => {
            product.text = `${product.name}`;
            product.name = `${product.name}`;
          });
        })
        .catch(error => {
          this.$error("Failed to load products.", error);
        })
    },
    associateProduct() {
      this.creating = true;
      axios.put(`${process.env.VUE_APP_API_URL}/v1/product/${this.id}/associate`, this.associatedProduct)
        .then(() => {
          $('#closeAssociateProductModal').click();
          this.$success("Associated new product.");
          this.creating = false;
          this.associatedProduct = {
            child_product_id: null,
            quantity: 1
          }
          this.products = [];
          this.loadAssociatedProducts();
        })
        .catch(error => {
          this.$error("Failed to associate new product.", error);
          this.creating = false;
        })
    },
    openProductModal(id, quantity) {
      this.associatedProduct.child_product_id = id;
      this.associatedProduct.quantity = quantity;
      $('#editProductModal').modal('show');
    },
    editProduct() {
      this.updating = true;
      axios.patch(`${process.env.VUE_APP_API_URL}/v1/product/associate/${this.associatedProduct.child_product_id}`, this.associatedProduct)
        .then(() => {
          $('#closeEditProductModal').click();
          this.$success("Product quantity updated.");
          this.updating = false;
          this.products = [];
          this.loadAssociatedProducts();
        })
        .catch(error => {
          this.$error("Failed to update product.", error);
          this.updating = false;
        })
    },
    removeProduct(id) {
      axios.delete(`${process.env.VUE_APP_API_URL}/v1/product/associate/${id}`)
        .then(() => {
          this.products = [];
          this.loadAssociatedProducts();
          this.$success("Associated product deleted.");
        })
        .catch(error => {
          this.$error("Failed to delete associated product.", error);
        })
    },
    saveChanges() {
      this.updating = true;
      let data = new FormData();
      data.append('name', this.product.name);
      data.append('type', this.product.type);
      axios.patch(`${process.env.VUE_APP_API_URL}/v1/product/${this.id}`, data)
        .then(() => {
          this.$success("Updated product.");
          this.updating = false;
          this.edit = false;
          this.loadProduct();
        })
        .catch(error => {
          this.$error("Failed to update product.", error);
          this.updating = false;
        })
    }
  }
}
</script>

<style scoped></style>